import { store } from "../store";
import { SNACKBAR_ACTION } from "../store/root/root.actions";

export const TryCatchAction = <
  T extends { init: Function; success: Function; failed: Function }
>(
  action?: T,
  errorMessage?: string
) => {
  return (_: Object, __?: string, descriptor?: PropertyDescriptor) => {
    const fn: Function = descriptor?.value;
    if (!descriptor) {
      descriptor = {};
    }
    descriptor.value = async function (...args: any[]) {
      try {
        if (action) {
          store.dispatch(action.init());
        }
        const response = await fn.apply(this, args);
        if (action) {
          store.dispatch(action.success(response));
        }
        return response;
      } catch (err) {
        if (action) {
          store.dispatch(
            action.failed({
              displayMessage: errorMessage || "Failed to load",
              internalMessage: err.message,
            })
          );
          displayErrorMessage(err.message);
        }
      }
    };
  };
};

export const displayErrorMessage = (message: string) => {
  store.dispatch(SNACKBAR_ACTION({ open: true, type: "error", message }));
};
